import { useState } from "react";
import { Building2, CheckCircle2, Loader2, Link2 } from "lucide-react";
import AssignQuoteToOrgModal from "./AssignQuoteToOrgModal";

export default function QuoteOrganizationPanel({ quote, orgCreating, onCreateOrganization, onAssigned }) {
  const [assignOpen, setAssignOpen] = useState(false);
  if (quote.status !== "Accepted") return null;
  return (
    <div className="rounded-2xl border border-emerald-200 bg-emerald-50/50 p-5 dark:border-emerald-500/20 dark:bg-emerald-500/10" data-testid="quote-organization-panel">
      {quote.org_id ? (
        <>
          <p className="flex items-center gap-2 text-sm font-bold text-emerald-800 dark:text-emerald-400">
            <CheckCircle2 size={16} /> Assigned to Organization
          </p>
          <p className="mt-1 text-sm font-semibold text-emerald-700 dark:text-emerald-400" data-testid="quote-organization-id">{quote.org_id}</p>
        </>
      ) : (
        <>
          <p className="text-sm font-semibold text-slate-700 dark:text-slate-300">
            This quote has been accepted. Create a new Organization, or assign it to an existing organization to replace its current billing quote.
          </p>
          <div className="mt-3 flex flex-wrap gap-3">
            <button
              type="button"
              onClick={onCreateOrganization}
              disabled={orgCreating}
              data-testid="quote-create-organization-btn"
              className="inline-flex items-center gap-2 rounded-xl bg-emerald-600 px-4 py-2.5 text-sm font-bold text-white transition-colors duration-200 hover:bg-emerald-700 disabled:opacity-50"
            >
              {orgCreating ? <Loader2 size={16} className="animate-spin" /> : <Building2 size={16} />}
              Create New Organization
            </button>
            <button
              type="button"
              onClick={() => setAssignOpen(true)}
              data-testid="quote-assign-existing-org-btn"
              className="inline-flex items-center gap-2 rounded-xl border border-emerald-300 bg-white px-4 py-2.5 text-sm font-bold text-emerald-700 transition-colors duration-200 hover:bg-emerald-50 dark:border-emerald-500/30 dark:bg-transparent dark:text-emerald-400 dark:hover:bg-emerald-500/10"
            >
              <Link2 size={16} /> Assign to Existing Organization
            </button>
          </div>
        </>
      )}
      <AssignQuoteToOrgModal
        open={assignOpen}
        quote={quote}
        onClose={() => setAssignOpen(false)}
        onAssigned={(data) => {
          setAssignOpen(false);
          onAssigned?.(data);
        }}
      />
    </div>
  );
}

